/**
 * Terms API helpers
 */

const BACKEND_URL = process.env.REACT_APP_BACKEND_URL || "";
const API = `${BACKEND_URL}/api`;

/**
 * Accept current terms
 * @param {string} requestId
 * @param {string} token - Auth token
 * @returns {Promise<Object>}
 */
export async function acceptTerms(requestId, token) {
  const response = await fetch(`${API}/requests/${requestId}/terms/accept`, {
    method: 'PATCH',
    headers: {
      'Authorization': `Bearer ${token}`
    }
  });

  if (!response.ok) {
    const error = await response.json();
    throw new Error(error.detail || 'Failed to accept terms');
  }

  return response.json();
}

/**
 * Counter terms with new proposal
 * @param {string} requestId
 * @param {Object} counterData - {commissionPct, notes}
 * @param {string} token
 * @returns {Promise<Object>}
 */
export async function counterTerms(requestId, counterData, token) {
  const response = await fetch(`${API}/requests/${requestId}/terms/counter`, {
    method: 'PATCH',
    headers: {
      'Content-Type': 'application/json',
      'Authorization': `Bearer ${token}`
    },
    body: JSON.stringify(counterData)
  });

  if (!response.ok) {
    const error = await response.json();
    throw new Error(error.detail || 'Failed to counter terms');
  }

  return response.json();
}
